import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledWrapper = styled.div `
    display: flex;
    width: 150px;
    flex-shrink: 0;
    overflow: visible;
    margin-right: 40px;
    height: calc(100vh - 250px);
    position: sticky;
    top: 174px;
`;
const ProgressWrapper = ({ passRef, ...props }) => _jsx(StyledWrapper, { ref: passRef, ...props });
export default ProgressWrapper;
